<!--
  WARNING!

  this file was automatically generated and should be updated using:

  ng g lazy-component extensions/quoting/shared/product-add-to-quote/product-add-to-quote.component.ts
-->
<ng-template #anchor></ng-template>
